"use strict";

exports.__esModule = true;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _parsingUtils = require("../../helpers/modules-helpers/parsing-utils");

var _d3visualization = require("../../helpers/modules-helpers/d3visualization");

var _d3visualization2 = _interopRequireDefault(_d3visualization);

var _electrify = require("../../../src/styles/electrify.css");

var _electrify2 = _interopRequireDefault(_electrify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var D3ElectrifyChart = function (_React$Component) {
  (0, _inherits3.default)(D3ElectrifyChart, _React$Component);

  function D3ElectrifyChart() {
    (0, _classCallCheck3.default)(this, D3ElectrifyChart);
    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
  }

  D3ElectrifyChart.prototype.parsePureWebpackStats = function parsePureWebpackStats() {
    return (0, _parsingUtils.bundle)(this.props.pureWebpackStats, function (err, data) {
      return JSON.parse(data.data);
    });
  };

  D3ElectrifyChart.prototype.componentDidMount = function componentDidMount() {
    var root = this.parsePureWebpackStats();
    (0, _d3visualization2.default)({
      refs: this.refs,
      root: root
    });
  };

  D3ElectrifyChart.prototype.render = function render() {
    return _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement("input", {
        type: "search",
        className: _electrify2.default.searchBox,
        placeholder: "Search File...",
        ref: "search"
      }),
      _react2.default.createElement(
        "div",
        { className: _electrify2.default.modes },
        _react2.default.createElement("ul", { ref: "scaleList", className: _electrify2.default.scaleList })
      ),
      _react2.default.createElement(
        "div",
        { className: _electrify2.default.electrifyChartContainer },
        _react2.default.createElement("div", { className: _electrify2.default.electrifyChart, ref: "svg" })
      ),
      _react2.default.createElement("div", { ref: "paletteWrap" })
    );
  };

  return D3ElectrifyChart;
}(_react2.default.Component);

exports.default = D3ElectrifyChart;


D3ElectrifyChart.propTypes = {
  pureWebpackStats: _react.PropTypes.object
};


//////////////////
// WEBPACK FOOTER
// ../~/electrode-electrify-react-component/lib/components/sub-components/electrify.js
// module id = 619
// module chunks = 0